<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        :showEdit="false"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import costCenter from "@/models/modelosDeLiquidacion/Relations/costCenter";
import costCenters from "@/store/centrosDeCosto/costCenters";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.costCenters"),
      titleTable: "ModelosDeLiquidacion_CentroDeCostos",
      titleDelete: this.$tc("modelsLiquidations.toCostCenterLiquidation"),
      isLoading: true,
      maxWidth: ["500px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await costCenters.dispatch("getCostCenters");
    this.isLoading = false;
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (!modelsLiquidation.state.edit.csCostos) {
        return [];
      }

      if (modelsLiquidation.state.edit.csCostos.length === 0) {
        return [];
      } else {
        return modelsLiquidation.state.edit.csCostos.map((item) => {
          return costCenter.fromJson(item);
        });
      }
    },
    costCenters() {
      return costCenters.state.costCenters;
    },

    costCentersSelected() {
      if (
        !modelsLiquidation.state.edit ||
        !modelsLiquidation.state.edit.csCostos
      ) {
        return costCenters.state.costCenters;
      }

      return costCenters.state.costCenters.filter(
        (costCenter) =>
          !modelsLiquidation.state.edit.csCostos.some(
            (selected) => selected.csCostoId === costCenter.id
          )
      );
    },
    dataSelects() {
      return [
        {
          name: "idConcept",
          label: "Concepto",
          data: "",
          items: [],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },

    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addCostCenterToLiquidation")
          );
          this.dataSelects[0].items = this.costCentersSelected;
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.itemId = item.id;
          this.dataInputs[0].data = item.name;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editCostCenterToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = item;
          this.itemToDelete.liqModeloId = modelsLiquidation.state.edit.id;
          break;

        default:
          break;
      }
    },

    reset(value) {
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.items = [];
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addCostCenter(items);
          break;
        default:
          break;
      }
    },

    addCostCenter(form) {
      let payload = form;
      payload.liqModeloId = modelsLiquidation.state.edit.id;
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addCostCenter")
        .then(() => {
          this.showAlert(
            this.$tc("modelsLiquidations.addCostCenterToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorCostCenter"),
            "#ff8d58"
          );
        });
      this.reset(false);
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteCostCenter")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteCostCenterToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorCostCenter"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
